export default __webpack_public_path__ + "static/media/g12.7bcb6c91.webp";